<template>
    <div>
        <form id="change_pos_request_status">
            <div class="container p-3 pt-5 my-4 border in-border-header">
                <div class="section-header">
                    {{ $t('pos.change_pos_request_status') }}
                </div>
                <kt-row>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="current_status">
                                {{ $t('pos.request_current_status') }}
                            </kt-form-label>
                            <kt-form-control
                                    ref="current_status"
                                    dir="rtl"
                                    disabled
                                    name="current_status"
                                    id="current_status"
                                    v-model="current_status_str"
                            />
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="status">
                                {{ $t('pos.change_status') }}
                            </kt-form-label>
                            <select
                                    id="status"
                                    name="status"
                                    v-model="form_data.change_status"
                                    class="form-control kt-selectpicker-change-req-status"
                            >
                                <option
                                        v-for="status in statuses"
                                        v-bind:key="status.status"
                                        :value="status.status">
                                    {{ status.status_str }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-show="form_data.change_status == posStatuses.CORRECTION ||
                    current_status == posStatuses.CORRECTION" lg="10" md="10" xs="12">
                        <kt-form-group>
                            <kt-form-label for="description">
                                {{ $t('label.description') }}
                            </kt-form-label>

                            <kt-form-textarea v-model="form_data.description" dir="rtl" name="description"
                                              id="description"
                            ></kt-form-textarea>
                        </kt-form-group>
                    </kt-col>
                    <kt-col xl="2" lg="3" md="4" xs="5">
                        <kt-form-action class="mt-4">
                            <kt-button
                                    class="m-2"
                                    size="md"
                                    @click="changeStatus"
                                    variant="success"
                                    v-bind:wide="true"
                                    id="change_status"
                            >
                                {{ $t('pos.change_status') }}
                            </kt-button>
                        </kt-form-action>
                    </kt-col>
                </kt-row>
            </div>
        </form>
    </div>
</template>

<script>
import {posStatuses, posStatusStr} from '@/constants/PosStatus'
import $ from "jquery";
import {i18n} from '@/plugins/i18n';
import {posService} from '@/common/api.service'
import {KTApp} from '@/plugins/core/app';
import toastr from "toastr";


export default {
    name: "change-status",
    data() {
        return {
            posStatuses, posStatusStr,
            form_data: {
                change_status: null,
                description: null,
            },
            statuses: [
                {
                    status: posStatuses.END_OF_FLOW,
                    status_str: posStatusStr.get(posStatuses.END_OF_FLOW)
                },
                {
                    status: posStatuses.CORRECTION,
                    status_str: posStatusStr.get(posStatuses.CORRECTION)
                },
                {
                    status: posStatuses.PSP_VISITOR,
                    status_str: posStatusStr.get(posStatuses.PSP_VISITOR)
                },
                {
                    status: posStatuses.WAITING_TAX,
                    status_str: posStatusStr.get(posStatuses.WAITING_TAX)
                },
                {
                    status: posStatuses.SWITCH,
                    status_str: posStatusStr.get(posStatuses.SWITCH)
                },
                {
                    status: posStatuses.SWITCH_ERROR,
                    status_str: posStatusStr.get(posStatuses.SWITCH_ERROR)
                },
                {
                    status: posStatuses.SHAPARAK,
                    status_str: posStatusStr.get(posStatuses.SHAPARAK)
                },
                {
                    status: posStatuses.SHAPARAK_QUEUE,
                    status_str: posStatusStr.get(posStatuses.SHAPARAK_QUEUE)
                },
                {
                    status: posStatuses.SHAPARAK_ERROR,
                    status_str: posStatusStr.get(posStatuses.SHAPARAK_ERROR)
                },
                {
                    status: posStatuses.AGENCY,
                    status_str: posStatusStr.get(posStatuses.AGENCY)
                },
                {
                    status: posStatuses.BIND_SERIAL_TO_SWITCH,
                    status_str: posStatusStr.get(posStatuses.BIND_SERIAL_TO_SWITCH)
                },
                {
                    status: posStatuses.INDICATOR_TRANSACTION,
                    status_str: posStatusStr.get(posStatuses.INDICATOR_TRANSACTION)
                },
                {
                    status: posStatuses.COMPLETING_DOCUMENTS,
                    status_str: posStatusStr.get(posStatuses.COMPLETING_DOCUMENTS)
                },
                {
                    status: posStatuses.DISCARDED,
                    status_str: posStatusStr.get(posStatuses.DISCARDED)
                },
                {
                    status: posStatuses.CANCELING,
                    status_str: posStatusStr.get(posStatuses.CANCELING)
                },
                {
                    status: posStatuses.ACTIVE,
                    status_str: posStatusStr.get(posStatuses.ACTIVE)
                },
                {
                    status: posStatuses.FinalReject,
                    status_str: posStatusStr.get(posStatuses.FINAL_REJECT)
                },
            ]
        }
    },
    props: {
        current_status : {
            required : true
        },
        current_status_str: String,
        pos_request_id: String,
        description: String,
    },
    mounted() {
        this.afterDispach()
        this.form_data.description = this.description
    },
    methods: {
        changeStatus() {
            let btn = $('#change_status')
            let form = $('#change_pos_request_status')
            let params = {
                pos_request_id: this.pos_request_id,
                status: this.form_data.change_status,
                description: this.form_data.description,
            }
            KTApp.progress(btn)
            posService.changePosRequestStatus(params).then(response => {
                this.$router.push('/pos')
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                if (response.data) {
                    form.validate().showErrors(response.data.data)
                }
                this.showMsg(form, 'danger', response.data.message)
            }).finally(() => {
                KTApp.unprogress(btn)
            })
        },
        afterDispach() {
            $('.kt-selectpicker-change-req-status').selectpicker({
                size: 6,
                liveSearch: false,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_chose')
            });
        }
    },
    computed: {
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }

            return toastr
        },
    }
}
</script>

<style scoped>

</style>